<div fxLayout="row" fxLayoutAlign="start center" *ngIf="singleLabelValuePanelDto && singleLabelValuePanelDto.labelValueDto" >
    <div fxFlex="20"><p class="mat-text-muted mt-xs mb-xs">{{singleLabelValuePanelDto.labelValueDto.label | translate}}</p></div>
    <div>   </div>
    <div> <p class="mt-xs mb-xs ml-xs">{{singleLabelValuePanelDto.labelValueDto.value | translate}}</p></div>
</div>
